import { useCallback, useEffect, useRef, useState } from 'react';
import { siteApi } from '../admin/siteApi';
import { withWalletTurn, publishClaimWallet } from '../keno/walletTurns';

export const useVIPRewards = (owner) => {
  const [data, setData] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState(''), [claimed, setClaimed] = useState(null);
  const pending = useRef(false), mounted = useRef(false), requestId = useRef(null);
  const reading = useRef(false), readAt = useRef(0);
  const key = `gv_rakeback_pending_${owner}`;
  const reload = useCallback(async () => {
    if (pending.current || reading.current || Date.now() - readAt.current < 500) return;
    reading.current = true; readAt.current = Date.now();
    try { const value = await siteApi('/account/vip'); if (mounted.current && !pending.current) { setData(value); if (!requestId.current) setError(''); } }
    catch (failure) { if (mounted.current) setError(failure.message); }
    finally { reading.current = false; }
  }, []);
  useEffect(() => {
    mounted.current = true;
    try { requestId.current = localStorage.getItem(key); } catch { /* In-memory retry still works. */ }
    reload(); const poll = setInterval(() => { if (!document.hidden) reload(); }, 5000);
    window.addEventListener('focus', reload); window.addEventListener('gv-wallet-updated', reload);
    window.addEventListener('gv-wallet-turn-finished', reload);
    return () => { mounted.current = false; clearInterval(poll); window.removeEventListener('focus', reload); window.removeEventListener('gv-wallet-updated', reload); window.removeEventListener('gv-wallet-turn-finished', reload); };
  }, [key, reload]);
  const claim = async () => {
    if (pending.current || (!data?.can_claim && !requestId.current)) return;
    pending.current = true; setBusy(true); setError(''); setClaimed(null);
    const id = requestId.current || crypto.randomUUID(); requestId.current = id;
    try {
      try { localStorage.setItem(key, id); } catch { /* Keep request ID in memory. */ }
      const result = await withWalletTurn(owner, async () => {
        if (!mounted.current) throw new Error('Claim cancelled.');
        try {
          const value = await siteApi('/account/vip/rakeback/claim', { method: 'POST', body: JSON.stringify({ request_id: id }) });
          publishClaimWallet(owner, value); return value;
        } catch (failure) {
          try { publishClaimWallet(owner, await siteApi('/keno/wallet')); } catch { /* Preserve retry ID when offline. */ }
          throw failure;
        }
      });
      requestId.current = null; try { localStorage.removeItem(key); } catch { /* Ignore storage unavailability. */ }
      window.dispatchEvent(new CustomEvent('gv-reward-claimed', { detail: { user_id: owner, kind: 'rakeback', request_id: id, amount_minor: result.amount_minor } }));
      if (mounted.current) { setData(result.vip); setClaimed(result.amount_minor); }
      return result;
    } catch (failure) { if (mounted.current) setError(failure.message); }
    finally { pending.current = false; if (mounted.current) { setBusy(false); reload(); } }
  };
  return { data, busy, error, claimed, claim, reload, retryPending: Boolean(requestId.current) };
};